import React, { Component } from 'react';
import { compose, withProps, lifecycle } from "recompose"
import { withGoogleMap, GoogleMap, Marker, InfoWindow, DirectionsRenderer } from "react-google-maps" //npm install --save react-google-maps
//https://tomchentw.github.io/react-google-maps/
import queryString from 'query-string';

const containerElement = <div style={{ height: `99%` }} />;
const mapElement = <div style={{ height: `100%` }} />;

function getGpsBadgeClass(status) {
    if (!status) return 'veh-badge-secondary';
    const s = status.toUpperCase();
    if (s.includes('MOVING') || s.includes('ENROUTE') || s.includes('EN ROUTE')) return 'veh-badge-primary';
    if (s.includes('LOCATION') || s.includes('ARRIVED')) return 'veh-badge-info';
    if (s.includes('IDLE') || s.includes('WAIT') || s.includes('STAND')) return 'veh-badge-warning';
    if (s.includes('OFF')) return 'veh-badge-secondary';
    return 'veh-badge-default';
}

function getStatusBadgeClass(status) {
    if (!status) return 'veh-badge-secondary';
    const s = status.toUpperCase();
    if (s.includes('JOB') || s.includes('ACTIVE') || s.includes('ASSIGNED')) return 'veh-badge-primary';
    if (s.includes('AVAILABLE') || s.includes('FREE') || s.includes('OPEN')) return 'veh-badge-success';
    if (s.includes('COMPLETE') || s.includes('DONE') || s.includes('FINISH')) return 'veh-badge-teal';
    if (s.includes('BREAK') || s.includes('HOLD') || s.includes('PENDING')) return 'veh-badge-warning';
    if (s.includes('OFFLINE') || s.includes('INACTIVE') || s.includes('OFF')) return 'veh-badge-secondary';
    return 'veh-badge-default';
}
var userDefaultLatitude = 0;
var userDefaultLongitude = 0;

export const vehicleData = [
    {
        rideId: 4422521535
        , vehicleId: 5
        , vehicleNo: "MH05 EP 3700"
        , vehicleTypeId: 5
        , vehicleType: "VAN"
        , latitude: 40.731887783696465
        , longitude: - 73.86869420143684
        , gpsDateTimeStr: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
        , rideStatusId: 107
        , gpsstatus: "ON LOCATION"
        , statusId: 303
        , statusDescription: "ON JOB"
        , pickupDateTimeStr: "03/12/2021 13:26"
        , driverName: "Dharmendra"
        , mobileNo: "8652197699"
        , puStreet: "JFK Airport Terminal 4 NY 2001"
        , doStreet: "Manhantton Hotel, Hotel bridge, NY new york 1822"
        , puLatitude: 40.644418
        , puLongitude: - 73.789061
        , doLatitude: 40.70871557720287
        , doLongitude: - 73.99368082930151
        , speed: 20
        , pax: 2
    },
    {
        rideId: 4422521535
        , vehicleId: 5
        , vehicleNo: "MH05 EP 3701"
        , vehicleTypeId: 5
        , vehicleType: "VAN"
        , latitude: 40.907610229562756
        , longitude: - 72.8262761242683
        , gpsDateTimeStr: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
        , rideStatusId: 107
        , gpsstatus: "ON LOCATION"
        , statusId: 303
        , statusDescription: "ON JOB"
        , pickupDateTimeStr: "03/12/2021 13:26"
        , driverName: "Dharmendra"
        , mobileNo: "8652197699"
        , puStreet: "Manhantton Hotel, Hotel bridge, NY new york 1822"
        , doStreet: "JFK Airport"
        , puLatitude: 40.644418
        , puLongitude: - 73.789061
        , doLatitude: 40.70871557720287
        , doLongitude: - 73.99368082930151
        , speed: 20
        , pax: 3
    },
    {
        rideId: 4422521535
        , vehicleId: 5
        , vehicleNo: "MH05 EP 3702"
        , vehicleTypeId: 5
        , vehicleType: "VAN"
        , latitude: 40.81193162529278
        , longitude: - 74.29548149014192
        , gpsDateTimeStr: new Date().toLocaleDateString() + ' ' + new Date().toLocaleTimeString()
        , rideStatusId: 107
        , gpsstatus: "ON LOCATION"
        , statusId: 303
        , statusDescription: "ON JOB"
        , pickupDateTimeStr: "03/12/2021 13:26"
        , driverName: "Dharmendra"
        , mobileNo: "8652197699"
        , puStreet: "JFK Airport"
        , doStreet: "Manhantton Hotel"
        , puLatitude: 40.644418
        , puLongitude: - 73.789061
        , doLatitude: 40.70871557720287
        , doLongitude: - 73.99368082930151
        , speed: 20
        , pax: 5
    },

]

export class TrackingComponent extends Component {
    static displayName = TrackingComponent.name;
    constructor(props) {
        super(props);
        this.state = {
            rideId: 0,
            trackingData: [],
            isLoading: true,
        }
        this.getUserLocationData = this.getUserLocationData.bind(this);
        this.getTrackingData = this.getTrackingData.bind(this);
        this.refreshMap = this.refreshMap.bind(this);
    }

    async componentDidMount() {
        const parsed = queryString.parse(this.props.location.search);
        // Fire user-location in background — only needed for empty-map default center
        this.getUserLocationData(parsed);
        // Show map as soon as tracking data is ready
        await this.getTrackingData(parsed);
        this.setState({ isLoading: false });
    }

    refreshMap() {
        window.location.reload(false);
    }

    async getUserLocationData(parsed) {
        try {
            if (parsed) {
                const accountId = parseInt(parsed.accountId);
                const userId = parseInt(parsed.userId);
                const response = await fetch('tracking-api/user-default-location/' + userId + '/' + accountId, {
                    method: 'GET',
                    headers: { 'Content-Type': 'application/json' },
                });
                const data = await response.json();
                if (data.userDefaultLocations && data.userDefaultLocations.length > 0) {
                    userDefaultLatitude = data.userDefaultLocations[0].userDefaultLatitude;
                    userDefaultLongitude = data.userDefaultLocations[0].userDefaultLongitude;
                }
            }
        } catch (e) {
            console.log(e);
        }
    }

    async getTrackingData(parsed) {
        try {
            if (parsed) {
                this.setState({ rideId: parseInt(parsed.rideId) || 0 });
                const request = {
                    AccountId: parseInt(parsed.accountId),
                    LocationId: parseInt(parsed.locationId),
                    RideId: parseInt(parsed.rideId),
                    VgTypeId: parsed.vgTypeId !== undefined ? parsed.vgTypeId : "0",
                    LoginUserId: parsed.userId !== undefined ? parseInt(parsed.userId) : 0,
                };
                const response = await fetch('tracking-api/0/track-list', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(request),
                });
                const data = await response.json();
                const trackingData = data.trackVehicles ?? [];
                this.setState({ trackingData });
            }
        } catch (e) {
            console.log(e);
        }
    }

    render() {
        const { isLoading, trackingData, rideId } = this.state;
        return (
            <div className="map-container">
                {isLoading && (
                    <div className="page-loading-backdrop">
                        <div className="page-loading-popup">
                            <div className="page-loading-popup-icon">
                                <i className="fas fa-circle-notch fa-spin"></i>
                            </div>
                            <div className="page-loading-popup-body">
                                <p className="page-loading-popup-title">Loading Map</p>
                                <p className="page-loading-popup-sub">Fetching vehicle locations, please wait...</p>
                            </div>
                        </div>
                    </div>
                )}
                {!isLoading && trackingData.length === 0 && <DefaultVehicleMap refreshMap={this.refreshMap} />}
                {!isLoading && trackingData.length > 0 && rideId > 0 && <SingleVehicleMap vehicleDetails={trackingData} refreshMap={this.refreshMap} />}
                {!isLoading && trackingData.length > 0 && !rideId && <MultipleVehicleMap vehicleDetails={trackingData} refreshMap={this.refreshMap} />}
            </div>
        );
    }
}

const DefaultVehicleMap = compose(
    withProps({
        containerElement: containerElement,
        mapElement: mapElement,
    }),
    withGoogleMap,
)(props =>
    <GoogleMap
        defaultZoom={8}
        defaultCenter={{ lat: userDefaultLatitude, lng: userDefaultLongitude }}
        defaultOptions={{
            mapTypeControl: true,
            streetViewControl: true,
            zoomControl: true,
            fullscreenControl: false,
            minZoom: 2,
            maxZoom: 15,
            gestureHandling: "greedy",
            disableDefaultUI: true
        }}
    >
        {props.isMarkerShown && <Marker position={{ lat: userDefaultLatitude, lng: userDefaultLongitude }} />}
        <div><button type="button" className="map-refresh-button" onClick={props.refreshMap}> Refresh</button></div>
    </GoogleMap>
);

const SingleVehicleMap = compose(
    withProps({
        containerElement: containerElement,
        mapElement: mapElement,
    }),
    withGoogleMap,
    lifecycle({
        componentDidMount() {
            const refs = {}
            const DirectionsService = new window.google.maps.DirectionsService();

            var start = new window.google.maps.LatLng(parseFloat(this.props.vehicleDetails[0].latitude), parseFloat(this.props.vehicleDetails[0].longitude));
            var end = "";
            if (this.props.vehicleDetails[0].rideStatusId == 108) {
                end = new window.google.maps.LatLng(parseFloat(this.props.vehicleDetails[0].doLatitude), parseFloat(this.props.vehicleDetails[0].doLongitude));
            } else {
                end = new window.google.maps.LatLng(parseFloat(this.props.vehicleDetails[0].puLatitude), parseFloat(this.props.vehicleDetails[0].puLongitude));
            }

            DirectionsService.route({
                origin: start,
                destination: end,
                travelMode: window.google.maps.TravelMode.DRIVING,
                durationInTraffic: true
            }, (result, status) => {
                if (status === window.google.maps.DirectionsStatus.OK) {
                    this.setState({
                        directions: result,
                        eta: result.routes[0].legs[0].duration.text,
                        bounds: null,
                        showInfoIndex: 0,
                        onMapMounted: ref => {
                            refs.map = ref;
                            //console.log("Zoom to markers");
                            const bounds = new window.google.maps.LatLngBounds();
                            ref.props.children.forEach((child) => {
                                if (child.type === Marker) {
                                    bounds.extend(new window.google.maps.LatLng(child.props.position.lat, child.props.position.lng));
                                }
                            })
                            ref.fitBounds(bounds);
                        },
                        onBoundsChanged: () => {
                            this.setState({
                                bounds: refs.map.getBounds(),
                                center: refs.map.getCenter(),
                            })
                        },
                        showInfo: (a) => {
                            this.setState({ showInfoIndex: a })
                        },
                        handleCloseCall: () => {
                            this.setState({ showInfoIndex: '' })
                        },
                        showAddressInfo: (a) => {
                            this.setState({ showAddessWindow: true })
                        },
                        handleCloseAddress: (a) => {
                            this.setState({ showAddessWindow: false })
                        },
                    });
                } else {
                    console.error(`error fetching directions ${result}`);
                }
            });
        }
    })
)(props =>
    <GoogleMap
        ref={props.onMapMounted}
        defaultZoom={15}
        defaultOptions={{
            mapTypeControl: true,
            streetViewControl: true,
            zoomControl: true,
            fullscreenControl: false,
            minZoom: 2,
            maxZoom: 18,
            gestureHandling: "greedy"
        }}
        defaultCenter={{ lat: parseFloat(props.vehicleDetails[0].latitude), lng: parseFloat(props.vehicleDetails[0].longitude) }}
        onBoundsChanged={props.onBoundsChanged}>

        {props.vehicleDetails[0].rideStatusId === 108 &&
            <Marker
                position={{ lat: parseFloat(props.vehicleDetails[0].doLatitude), lng: parseFloat(props.vehicleDetails[0].doLongitude) }}
                onClick={() => { props.showAddressInfo() }}
            >
                {(props.showAddessWindow) &&
                    <InfoWindow onCloseClick={props.handleCloseAddress} options={{ maxWidth: 100 }} >
                        <div style={{ paddingBottom: 3 + 'px' }}>
                            <span>{props.vehicleDetails[0].doStreet}</span>
                        </div>
                    </InfoWindow>}
            </Marker>}

        {props.vehicleDetails[0].rideStatusId != 108 && <Marker
            position={{ lat: parseFloat(props.vehicleDetails[0].puLatitude), lng: parseFloat(props.vehicleDetails[0].puLongitude) }}
            onClick={() => { props.showAddressInfo() }}
        >
            {(props.showAddessWindow) &&
                <InfoWindow onCloseClick={props.handleCloseAddress} options={{ maxWidth: 100 }} >
                    <div style={{ paddingBottom: 3 + 'px' }}>
                        <span>{props.vehicleDetails[0].puStreet}</span>
                    </div>
                </InfoWindow>}
        </Marker>}

        {props.vehicleDetails.map((marker, index) =>
            <Marker
                key={index}
                position={{ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }}
                icon={{
                    url: "https://member.utwiz.com/TrackVehicle/Car/0.png",
                    anchor: new window.google.maps.Point(20, 20),
                    scaledSize: new window.google.maps.Size(30, 30)
                }}
                onClick={() => { props.showInfo(index) }}
            >
                {(props.showInfoIndex !== '') && (props.showInfoIndex == index) &&
                    <InfoWindow onCloseClick={props.handleCloseCall} options={{ maxWidth: 420 }} >
                        <div className="iw-container">
                            <div className="iw-ride-id"><i className="fas fa-hashtag"></i> Ride Id: <strong>{marker.rideId}</strong></div>
                            <table className="iw-table">
                                <tbody>
                                    <tr>
                                        <td colSpan="2"><span className="iw-label"><i className="fas fa-user"></i> Crew Name</span><br /><span className="iw-value">{marker.paxName.replace(';', ',')}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="iw-label"><i className="fas fa-car"></i> Vehicle</span><br /><span className="iw-value">{marker.vehicleNo}</span></td>
                                        <td><span className="iw-label"><i className="fas fa-id-badge"></i> Driver</span><br /><span className="iw-value">{marker.driverName}</span> <span className="iw-badge">{marker.statusDescription}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="iw-label"><i className="fas fa-satellite-dish"></i> Last GPS</span><br /><span className="iw-value">{marker.gpsDateTimeStr}</span></td>
                                        <td><span className="iw-label"><i className="fas fa-clock"></i> Pickup Time</span><br /><span className="iw-value">{marker.pickupDateTimeStr}</span></td>
                                    </tr>
                                    <tr>
                                        <td className="iw-addr"><span className="iw-label"><i className="fas fa-map-marker-alt iw-pu-icon"></i> Pick-up</span><br /><span className="iw-value">{marker.puStreet}</span></td>
                                        <td className="iw-addr"><span className="iw-label"><i className="fas fa-map-marker-alt iw-do-icon"></i> Drop-off</span><br /><span className="iw-value">{marker.doStreet}</span></td>
                                    </tr>
                                    <tr>
                                        <td><span className="iw-label"><i className="fas fa-hourglass-half"></i> {props.vehicleDetails[0]?.rideStatusId === 108 ? "ETD" : "ETA"}</span><br /><span className="iw-value iw-eta">{props.eta}</span></td>
                                        <td><span className="iw-label"><i className="fas fa-tachometer-alt"></i> Speed</span><br /><span className="iw-value">{marker.speed.toFixed(1)} MPH</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </InfoWindow>}
            </Marker>
        )}



        {props.directions && <DirectionsRenderer directions={props.directions} options={{
            polylineOptions: {
                strokeColor: '#1a73e8',
                strokeOpacity: 0.85,
                strokeWeight: 5,
            },
            suppressMarkers: true
        }} />}
        <div><button type="button" className="map-refresh-button" onClick={props.refreshMap}> Refresh</button></div>
    </GoogleMap>

);

const MultipleVehicleMap = compose(
    withProps({
        containerElement: containerElement,
        mapElement: mapElement,
    }),
    withGoogleMap,
    lifecycle({

        componentDidMount() {
            this.loadDetails(this.props.vehicleDetails)
        },

        loadDetails(data) {
            const refs = {}
            this.setState({
                rawData: data,
                bounds: null,
                showInfoIndex: '',
                isShowlist: false,
                onMapMounted: ref => {
                    refs.map = ref;
                    //console.log("Zoom to markers");
                    const bounds = new window.google.maps.LatLngBounds();
                    data.forEach(item =>
                        bounds.extend(new window.google.maps.LatLng(item.latitude, item.longitude))
                    );
                    if (ref != null) {
                        ref.fitBounds(bounds);
                    }
                },
                onBoundsChanged: () => {
                    this.setState({
                        bounds: refs.map.getBounds(),
                        center: refs.map.getCenter(),
                    })
                },
                showInfo: (a) => {
                    this.setState({ showInfoIndex: a })
                },
                handleFocusVehicle: (a) => {

                    this.setState({ showInfoIndex: a, zoomLevel: 18, center: { lat: data[a].latitude, lng: data[a].longitude } })
                },
                handleCloseCall: () => {
                    this.setState({ showInfoIndex: '' })
                },
                handleToggleButton: () => {
                    this.setState({ isShowlist: !this.state.isShowlist, showInfoIndex: '', zoomLevel: undefined });
                    const bounds = new window.google.maps.LatLngBounds();
                    data.forEach(item =>
                        bounds.extend(new window.google.maps.LatLng(item.latitude, item.longitude))
                    );
                    refs.map.fitBounds(bounds);
                },
                handleShowAll: () => {
                    const bounds = new window.google.maps.LatLngBounds();
                    data.forEach(item =>
                        bounds.extend(new window.google.maps.LatLng(item.latitude, item.longitude))
                    );
                    this.setState({ showInfoIndex: '', zoomLevel: undefined, center: undefined });
                    if (refs.map) refs.map.fitBounds(bounds);
                },
                handleExportExcel: () => {
                    const headers = ['Vehicle No', 'Vehicle Type', 'Pax', 'Driver Name', 'Pickup Time', 'Last GPS Time', 'GPS Status', 'Trip Status'];
                    const rows = data.map(item => [
                        item.vehicleNo,
                        item.vehicleType,
                        item.pax,
                        item.driverName,
                        item.pickupDateTimeStr,
                        item.gpsDateTimeStr,
                        item.gpsstatus,
                        item.statusDescription,
                    ]);
                    const csvContent = [headers, ...rows]
                        .map(row => row.map(cell => `"${(cell ?? '').toString().replace(/"/g, '""')}"`).join(','))
                        .join('\r\n');
                    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `fleet_${new Date().toISOString().slice(0, 10)}.csv`;
                    a.click();
                    URL.revokeObjectURL(url);
                },
            });
        }
    })
)(props =>
    <div style={{ height: '100%', position: 'relative' }}>
        <GoogleMap
            ref={props.onMapMounted}
            defaultOptions={{
                mapTypeControl: true,
                streetViewControl: true,
                zoomControl: true,
                fullscreenControl: false,
                minZoom: 2,
                maxZoom: 18,
                gestureHandling: "greedy"
            }}
            zoom={props.zoomLevel}
            center={props.center}
            onBoundsChanged={props.onBoundsChanged}>
            {props.rawData != null && props.rawData.map((marker, index) =>
                <Marker
                    key={index}
                    position={{ lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude) }}
                    icon={{
                        url: "https://member.utwiz.com/TrackVehicle/Car/0.png",
                        anchor: new window.google.maps.Point(20, 20),
                        scaledSize: new window.google.maps.Size(30, 30)
                    }}
                    onClick={() => { props.showInfo(index) }}
                >
                    {(props.showInfoIndex !== '') && (props.showInfoIndex == index) &&
                        <InfoWindow onCloseClick={props.handleCloseCall} options={{ maxWidth: 420 }} >
                            <div className="iw-container">
                                <div className="iw-ride-id"><i className="fas fa-hashtag"></i> Ride Id: <strong>{marker.rideId}</strong></div>
                                <table className="iw-table">
                                    <tbody>
                                        <tr>
                                            <td colSpan="2"><span className="iw-label"><i className="fas fa-user"></i> Crew Name</span><br /><span className="iw-value">{marker.paxName.replace(';', ',')}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="iw-label"><i className="fas fa-car"></i> Vehicle</span><br /><span className="iw-value">{marker.vehicleNo}</span></td>
                                            <td><span className="iw-label"><i className="fas fa-id-badge"></i> Driver</span><br /><span className="iw-value">{marker.driverName}</span> <span className="iw-badge">{marker.statusDescription}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="iw-label"><i className="fas fa-satellite-dish"></i> Last GPS</span><br /><span className="iw-value">{marker.gpsDateTimeStr}</span></td>
                                            <td><span className="iw-label"><i className="fas fa-clock"></i> Pickup Time</span><br /><span className="iw-value">{marker.pickupDateTimeStr}</span></td>
                                        </tr>
                                        <tr>
                                            <td className="iw-addr"><span className="iw-label"><i className="fas fa-map-marker-alt iw-pu-icon"></i> Pick-up</span><br /><span className="iw-value">{marker.puStreet}</span></td>
                                            <td className="iw-addr"><span className="iw-label"><i className="fas fa-map-marker-alt iw-do-icon"></i> Drop-off</span><br /><span className="iw-value">{marker.doStreet}</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="iw-label"><i className="fas fa-users"></i> Pax</span><br /><span className="iw-value">{marker.pax}</span></td>
                                            <td><span className="iw-label"><i className="fas fa-tachometer-alt"></i> Speed</span><br /><span className="iw-value">{marker.speed.toFixed(1)} MPH</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </InfoWindow>}
                </Marker>
            )}
            <div><button type="button" className="map-refresh-button" onClick={props.refreshMap}> Refresh</button></div>
        </GoogleMap>
        <div id="map-body">
            <div id="map-list-data" className={`card${props.isShowlist ? ' visible' : ''}`}>
                <div className="fleet-list-header">
                    <i className="fas fa-satellite-dish"></i>&nbsp; Fleet Overview
                    <div className="fleet-list-header-right">
                        <span className="fleet-list-count">{props.rawData ? props.rawData.length : 0} vehicles</span>
                        <a className="fleet-show-all-link" onClick={props.handleShowAll} title="Zoom map to fit all vehicles">
                            <i className="fas fa-expand-arrows-alt"></i> All Vehicles
                        </a>
                        <a className="fleet-export-link" onClick={props.handleExportExcel} title="Export to Excel">
                            <i className="fas fa-file-excel"></i> Export
                        </a>
                    </div>
                </div>
                <div className="card-body table-responsive p-0 fleet-list-body">
                    <table className="table table-head-fixed table-hover fleet-list-table mb-0">
                        <thead>
                            <tr>
                                <th style={{ width: 32 }}></th>
                                <th><i className="fas fa-car"></i> Vehicle</th>
                                <th><i className="fas fa-tag"></i> Type</th>
                                <th><i className="fas fa-users"></i> Pax</th>
                                <th><i className="fas fa-id-badge"></i> Driver</th>
                                <th><i className="fas fa-clock"></i> Pickup Time</th>
                                <th><i className="fas fa-satellite-dish"></i> Last GPS</th>
                                <th><i className="fas fa-signal"></i> GPS Status</th>
                                <th><i className="fas fa-info-circle"></i> Trip Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {props.rawData != null && props.rawData.map((item, j) =>
                                <tr key={j}>
                                    <td>
                                        <button className="fleet-focus-btn" title="Focus on map" onClick={() => { props.handleFocusVehicle(j) }}>
                                            <i className="fas fa-crosshairs"></i>
                                        </button>
                                    </td>
                                    <td className="fleet-vehicle-no">{item.vehicleNo}</td>
                                    <td>{item.vehicleType}</td>
                                    <td><span className="fleet-pax-count"><i className="fas fa-user"></i> {item.pax}</span></td>
                                    <td>{item.driverName}</td>
                                    <td>{item.pickupDateTimeStr}</td>
                                    <td className="fleet-gps-time">{item.gpsDateTimeStr}</td>
                                    <td><span className={`veh-badge ${getGpsBadgeClass(item.gpsstatus)}`}>{item.gpsstatus}</span></td>
                                    <td><span className={`veh-badge ${getStatusBadgeClass(item.statusDescription)}`}>{item.statusDescription}</span></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div id="bottom_bar">
            <span id="bottom_menu">
                <a className="btn btn-success btn-sm btn-block" onClick={props.handleToggleButton}>Click here to show/hide list of vehicles</a>
            </span>
        </div>
    </div>
);

